module.exports = __webpack_public_path__ + "static/media/Reshenie_SD_Formoplast_OSA_GFO 2017_22.05.2018.c8429ec3.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2018/Reshenie_SD_Formoplast_OSA_GFO 2017_22.05.2018.pdf
// module id = 141
// module chunks = 0